import { render, staticRenderFns } from "./PermissionsControl.vue?vue&type=template&id=1883d0fc&"
import script from "./PermissionsControl.vue?vue&type=script&lang=js&"
export * from "./PermissionsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports